
export const experiences = [
    {
      id: 1,
      title: 'Software Technologies Intern',
      company: "Centre for Development of Advanced Computing",
      logo:"",
      duration: "(August 2024 - Sept 2025)",
      link:'https://wblp.in/',
      techstack:'Flutter, Dart, APIs, MySql, Git',
      details:'Built a Flutter application for the Work-Based Learning Program, enhancing user experience through intuitive design and seamless navigation. Improved interactivity by integrating modal widgets and collaborated with teams to optimize overall usability.',
      image:'https://images.shiksha.com/mediadata/images/1566558151phpCUWLvb.jpeg',

    },
    {
      id: 2,
      title: 'Full Stack Development Intern',
      company: "HopingMinds",
      logo:"",
      duration: "(January 2024 - June 2024)",
      link:'https://github.com/manpreet-mann/order-munch-Food-Delivery-Website-',
      techstack:'React.js, HTML, CSS, JS, Node.js, Express.js, MongoDb, Git',
      details:'Developed a solid foundation in Web Development and made a responsive food delivery website, enhancing user experience with the features like user authentication, adding items to cart, secure payment integration and order tracking.',
      image:'https://cdn-icons-png.flaticon.com/512/2210/2210153.png',

    }
  ]